import isEmpty from 'lodash/isEmpty';

import { buildLinkScopeWhere, buildScopeWhere } from './scope-predicate';

export const DEFAULT_FILTERS = Object.freeze({
  childType: null,
  childId: null,
  action: null,
  userSearchTerm: null,
  dateRange: null,
});

export function isFilterActive(filters) {
  const { childType, childId, action, userSearchTerm, dateRange } = filters;
  return Boolean(childType || childId || action || userSearchTerm || dateRange);
}

export function buildChildTypeScopeWhere({ composedMap, recordRef, childType, childIds }) {
  if (isEmpty(childIds)) return { _or: [] };
  return buildLinkScopeWhere({
    composedMap,
    parentEntity: recordRef.entity,
    parentId: recordRef.scopeValues.id,
    childEntity: childType,
    childIds,
  });
}

export function resolveScope({ composedMap, recordRef, childType, childId, childIds }) {
  if (childId) {
    return { where: buildChildTypeScopeWhere({ composedMap, recordRef, childType, childIds: [childId] }) };
  }
  if (childType) {
    return { where: buildChildTypeScopeWhere({ composedMap, recordRef, childType, childIds: childIds ?? [] }) };
  }
  return {
    where: buildScopeWhere({ composedMap, entity: recordRef.entity, scopeValues: recordRef.scopeValues }),
  };
}

export function buildFilterTerms({ userSearchTerm, dateRange }) {
  const terms = [];
  if (!isEmpty(userSearchTerm)) {
    const term = `%${userSearchTerm}%`;
    terms.push({ _or: [{ userName: { _ilike: term } }, { userEmail: { _ilike: term } }] });
  }
  if (dateRange) {
    const { startDate, endDate } = dateRange;
    terms.push({ timestamp: { _gte: startDate.toISOString(), _lt: endDate.toISOString() } });
  }
  return terms;
}

export function buildFilterWhere(filters) {
  const terms = buildFilterTerms(filters);
  if (filters.action) terms.push({ action: { _eq: filters.action } });
  return { _and: terms };
}
